const ImgCard = () => {
  return (
    <>
      <div className="img-card-loader">
        <div className="img"></div>
        <p></p>
      </div>
    </>
  );
};

export default ImgCard;
